<app-main-contents>
  <app-title [title]="title"></app-title>
  <app-ura-contract-individual
    [merchandiseDivisionCd]="merchandiseDivisionCd"
    [hideContractName]="true"
  ></app-ura-contract-individual>
</app-main-contents>
